export const CHART_DEFAULTS = {
  DEFAULT_WIDTH: 1000,
  DEFAULT_HEIGHT: 500,
  LEGEND_WIDTH: 200,
  LEGEND_HEIGHT: 100,
  MARGIN: { top: 20, right: 30, left: 30, bottom: 80 },
} as const;

export interface ChartDimensions {
  chartWidth: number;
  chartHeight: number;
  margin: typeof CHART_DEFAULTS.MARGIN;
  fullHeight: number;
}

export interface TickCallback {
  x: number | string;
  y: number | string;
  index?: number;
  payload: {
    value: string | number;
  };
}
export interface ChartDataPoint {
  [key: string]: number | string;
}

export interface ReferenceLineInfo {
  y: number;
  yAxisId: string;
  label: string;
  stroke: string;
}
